import { EVENT_NAMES, type EventName } from './protocol';

const uuidV4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export type TelemetryEvent = { event: EventName; clientId: string; eventId: string };
export function validMetricsId(value: unknown): value is string { return typeof value === 'string' && uuidV4.test(value); }
export function parseTelemetryEvent(value: unknown): TelemetryEvent | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const body = value as Record<string, unknown>;
  if (Object.keys(body).some(key => !['event', 'clientId', 'eventId'].includes(key))) return null;
  if (!EVENT_NAMES.includes(body.event as EventName) || !validMetricsId(body.clientId) || !validMetricsId(body.eventId)) return null;
  return { event: body.event as EventName, clientId: body.clientId.toLowerCase(), eventId: body.eventId.toLowerCase() };
}
